import React from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../MobileMenu/MobileMenu';

const Header = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">

                            {/* Hamburger — visible only on mobile/tablet */}
                            <div className="col-3 col-lg-3 d-lg-none">
                                <MobileMenu />
                            </div>

                            {/* Logo — col-6 on mobile so it sits in the true center */}
                            <div className="col-6 col-lg-2 text-center text-lg-start">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        <img src={props.Logo} alt="logo" />
                                    </Link>
                                </div>
                            </div>

                            {/* Right spacer — balances the hamburger on mobile for true center logo */}
                            <div className="col-3 d-lg-none"></div>

                            {/* Desktop nav — hidden on mobile */}
                            <div className="col-lg-7 d-none d-lg-flex align-items-center">
                                <div
                                    id="navbar"
                                    className="collapse navbar-collapse navigation-holder justify-content-center show"
                                >
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0 mx-auto">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/home">Home</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/about">About</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/services">Services</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/channel-doctor">Channel Doctor</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/contact">Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </nav>
            </div>
        </header>
        );
};

export default Header;